import script from "./FamilyGroupPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FamilyGroupPage.vue?vue&type=script&setup=true&lang=ts"

import "./FamilyGroupPage.vue?vue&type=style&index=0&id=392e1543&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-392e1543"]])

export default __exports__